import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { OnlineShopsProps } from './online-shops.models';
import { useStyles } from './online-shops.styles';
import { ShopsList } from './shops-list';
import { Preloader } from '../../../common/preloader';

export const OnlineShops = ({ shops, isLoading }: OnlineShopsProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div data-testid="online-shops" className={classes.root}>
      <p className={classes.points} data-testid="points-description">
        {intl.formatMessage({ id: 'onlineShops.card.text' }, { sup: (chunks: ReactNode) => <sup>{chunks}</sup> })}
      </p>
      {isLoading && <Preloader />}
      {shops && <ShopsList shops={shops} />}
    </div>
  );
};
